import * as React from 'react';
import * as cx from 'classnames';

import SvgIcon, { SvgIconProps } from 'ha/ui/next/SvgIcon';
import LoveItIcon from 'streamline-icons/love-it.svg';

import { Theme, createStyles, withStyles, WithStyles } from '@material-ui/core';

const styles = (t: Theme) =>
  createStyles({
    'icon-small': {
      strokeWidth: '1.4px',
      fontSize: '18px',
    },
    'icon-medium': {
      strokeWidth: '1.4px',
      fontSize: '22px',
    },
    'favorite-light': {
      stroke: t.palette.error.main,
    },
    'favorite-dark': {
      stroke: t.palette.secondary.main,
    },
    'unfavorite-light': {
      stroke: t.palette.darkBlue.dark,
    },
    'unfavorite-dark': {
      stroke: t.palette.white.main,
    },
  });

type Styles = typeof styles;
type Variant = 'favorite' | 'unfavorite';
type Kind = 'light' | 'dark';
type Size = 'small' | 'medium';

interface Props {
  kind?: Kind;
  size?: Size;
}

type Control = (
  variant: Variant,
) => React.SFC<Props & SvgIconProps & WithStyles<Styles>>;

const FavoriteIcon: Control = variant => ({
  classes,
  kind = 'light',
  size = 'medium',
  ...rest
}) => (
  <SvgIcon
    className={cx(classes[`icon-${size}`], classes[`${variant}-${kind}`])}
    children={<LoveItIcon />}
    {...rest}
  />
);

function wrapStyles(variant: Variant) {
  return withStyles(styles)(FavoriteIcon(variant)) as React.ComponentType<
    Props
  >;
}

export default {
  Favorite: wrapStyles('favorite'),
  Unfavorite: wrapStyles('unfavorite'),
};
